module.exports = __webpack_public_path__ + "img/app_new_main_2.493e9ef7.jpg";